export const Solicitudes = () => {
    return (
        <div>
            <h1>Solicitudes</h1>
        </div>
    );
};
